"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackupStorage = void 0;
exports.BackupStorage = {
    // internal storage
    storage: {},
    // basic API
    getItem: function (key) {
        return this.storage[key];
    },
    setItem: function (key, val) {
        this.storage[key] = val;
    },
    removeItem: function (key) {
        delete this.storage[key];
    },
    clear: function () {
        this.storage = {};
    },
};
//# sourceMappingURL=BackupStorage.js.map